export default {
  path: '/2019VoteForTopTenChongqingMerchants',
  name: 'VoteForTopTenChongqingMerchants',
  component: () => import('./Home.vue'),
  redirect: '/2019VoteForTopTenChongqingMerchants/rules',
  meta: {
    title: '2019年度渝商评选',
  },
  children: [
    // {
    //   path: 'givelike',
    //   component: () => import('./GiveLike.vue'),
    //   name: 'VoteForgivelike',
    //   meta: {
    //     title: '2019年度渝商评选',
    //   },
    // },
     {
      path: 'winner-list',
      component: () => import('./WinnerList.vue'),
      name: 'WinnerList',
      meta: {
        title: '2019年度渝商评选',
      },
    },
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: 'VoteForRules',
      meta: {
        title: '2019年度渝商评选',
      },
    },
    {
      path: 'news',
      component: () => import('./RelatedNews.vue'),
      name: 'VoteForRelatedNews',
      meta: {
        title: '2019年度渝商评选',
      },
    },
    {
      path: 'detail',
      component: () => import('./DetailPage.vue'),
      name: 'VoteForDetail',
      meta: {
        title: '2019年度渝商评选',
      },
    },
    // {
    //   path: 'coin-record',
    //   component: () => import('./CoinRecord.vue'),
    //   name: 'VoteForCoinRecord',
    //   meta: {
    //     title: '2019年度渝商评选',
    //   },
    // },
  ],
};
